<template>
    <UnitInfo__sensors_template
        :class="classForValue"
        :unitId="unitId"
        :icon="icon"
        :title="$t('Unit.sensors.Fuel')"
        :statusClass="statusClass"
        :statusIcon="statusIcon"
        :value="_value"
        v-if="_showByValue"
    />
</template>

<script>
import UnitInfo__sensors_template from "@/components/units/sensors/UnitInfo__sensors_template.vue"
import {mapGetters} from "vuex";
import {isValueExist} from "@/lib/lib";
import unitLmsgMixin from "@/mixins/unitLmsgMixin";
export default {
    name: "UnitInfo__sensors_fuel_level",
    mixins: [unitLmsgMixin],
    inject: ['sensorsValues'],
    props:{
        unitId: Number,
        showIcon: {
            type: Boolean,
            default: () => true
        },
        showByValue: {
            type: Boolean,
            default: () => false,
        }
    },
    components:{
        UnitInfo__sensors_template,
    },
    data() {
        return {
        }
    },
    computed:{
        ...mapGetters([
        ]),
        value() {
            let value = this.unitLmsgSensors.fuel_level
            if(typeof value != "string" || typeof value != "number") {
                value = value?.text
            }
            return value
        },
        isValueExist() {
            return isValueExist(this.value)
        },
        _value() {
            return this.isValueExist ? this.value : '-'
        },
        classForValue() {
            return this.isValueExist ? this.$consts.classSensors.value : this.$consts.classSensors.no_value
        },
        _showByValue() {
            return this.showByValue ? this.isValueExist : true
        },
        statusClass(){
            return ''
        },
        statusIcon(){
            return ''
        },
        icon() {
            return this.showIcon ? 'reefer__fuel' : false
        }
    },
    watch: {
        value: {
            handler: function (val) {
                if(this.sensorsValues) {
                    this.sensorsValues.fuel_level = val
                }
            },
            immediate: true
        },
    },
    mounted() {
    },
    beforeUnmount() {
        if(this.sensorsValues) {
            delete this.sensorsValues.fuel_level
        }
    },
}
</script>

<style scoped>

</style>